import en from "./en";
import fr from "./fr";

export const resources = {
  en: en,
  fr: fr,
};
